import { BasicTextField } from '../BasicTextField/BasicTextField'

import type { FormFieldWrapper } from '@ngb-frontend/shared/types'

export const PostcodeField: React.FC<FormFieldWrapper> = (props) => (
  <BasicTextField
    {...props}
    field="postcode"
    labelKey="fields.postcode.label"
    onChange={(input) => (e) => {
      if (e.target.value.length > 8) return
      input.onChange(e)
    }}
  />
)
